export default function (currentDate) {
    if (!isNaN(currentDate)) {
        const formatter = new Intl.DateTimeFormat("en-NG", {
          dateStyle: "medium",
          timeStyle: "long",
        });
      
        let today = formatter.format(currentDate).toLowerCase();
        const saved = today.split("at");
        const nowDate = saved[0] ?? null;
        return nowDate 
    } else {
        return null;
    }
}
